import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber cocinar?',
  a: 'No. Si sabes abrir un empaque de queso y pelar una fruta, puedes usar este método.'
}, {
  q: '¿Los ingredientes son caros?',
  a: 'Al contrario. El método se basa en optimizar las compras en supermercados de bajo costo.'
}, {
  q: '¿Sirve para niños "picky eaters" (caprichosos)?',
  a: 'Sí, el método se basa en alimentos simples y reconocibles que los niños suelen aceptar mejor que las recetas complejas.'
}, {
  q: '¿Es un libro físico?',
  a: 'Es un PDF digital que puedes descargar de inmediato en tu celular o computador.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-24 px-6" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F]" data-id="element-15">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-16">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="border border-[#5C4B3A]/10 rounded-2xl overflow-hidden bg-[#FFF8F0]/50" data-id="element-17">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-18">
                  <span className="font-heading font-semibold text-lg text-[#2D6A4F]" data-id="element-19">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="text-[#E76F51] flex-shrink-0 ml-4" data-id="element-20">
                    <ChevronDownIcon size={24} data-id="element-21" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-22">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-23">
                      <div className="px-6 pb-5 text-[#5C4B3A]" data-id="element-24">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}